export default __webpack_public_path__ + "static/media/verizon.5681802e.webp";